<ng-container *ngIf="environmentVariables?.GUEST_CAN_VIEW_PRICES">
  <ng-container *ngIf="product && !stylePopup">
    <span class="position-relative" 
      [ngClass]="{
        'button-card': styleCard == true,
        'style-ar': lang == 'ar',
        'style-home-ar': styleCardHomeAr,
        'style-cart-page': styleCartPage,
        isGridView: isGridView == 'true',
        compareStyle: compareStyle,
        styleFavorites: styleFavorites,
        styleDetails: styleDetails
      }">
      <!-- not etisal -->
      <span class="d-flex" 
        *ngIf="product?.in_stock &&
          !product?.available_soon && 
          environmentVariables?.ADD_TO_CART_TEXT_EN != '‎ +‎ ‎'"
      >
        <button mat-raised-button *ngIf="product.amount == 0 || !product.amount" 
          class="blueButton no-shadow w-150px px-1"
          [ngClass]="{
            'h-sm-24px': source === 'details-bar'
          }"
          (click)="addProductToCart(product)" [ngStyle]="{ padding: customPadding }"
          style="outline: none !important" id="addToCart">
          <span *ngIf="!product?.preorder"
            class="add-to-cart-text px-2">
            {{
              environmentVariables?.ADD_TO_CART_TEXT_EN
              ? lang == "en"
              ? environmentVariables?.ADD_TO_CART_TEXT_EN
              : environmentVariables?.ADD_TO_CART_TEXT_AR
              : ("button.addToCart" | translate)
            }}
          </span>

          <span *ngIf="product?.preorder">
            {{ "productDetails.preorder" | translate }}
          </span>
        </button>

        <!-- decrement/increment amount -->
        <div class="control-btn-group w-100" *ngIf="product.amount > 0">
          <button mat-raised-button
            class="blueButton no-shadow w-50px"
            (click)="decrementAmountProduct(product)"
            id="decrementFromCart">
            <mat-icon class="material-icons fs-24 lh-24" aria-hidden="false">remove</mat-icon>
          </button>
          <span class="number-cart" [ngClass]="{'number-cart-width': source === 'details'}">
            {{ product.amount }}
          </span>
          <button mat-raised-button class="blueButton no-shadow w-50px"
            (click)="incrementAmountProduct(product)"
            [ngClass]="
              (product.max_per_order != null &&
                product.max_per_order <= product.amount) ||
              (product.can_buy != null &&
                product.can_buy <= product.amount) ||
              product.stock <= product.amount
                ? 'disabled'
                : ''"
            id="incrementToCart">
            <mat-icon class="material-icons fs-24 lh-24" aria-hidden="false">add</mat-icon>
          </button>
          <app-loading *ngIf="product.loading_cart"></app-loading>
        </div>
      </span>

      <!-- etisal btns -->
      <div *ngIf="product?.in_stock && !product?.available_soon &&
          environmentVariables?.ADD_TO_CART_TEXT_EN == '‎ +‎ ‎'">
        <button mat-raised-button *ngIf="product.amount == 0 || !product.amount" 
          class="blueButton no-shadow"
          [ngClass]="{
            'h-40px': source === 'details',
            'h-sm-24px': source === 'details-bar',
            'w-100': source === 'details' || source === 'details-bar',
            'px-1': source !== 'details',
            'd-flex align-items-center justify-center': (source === 'details' || source === 'details-bar'),
            'w-150px': source !== 'details' && source !== 'details-bar'
          }"
          (click)="addProductToCart(product)" [ngStyle]="{ padding: customPadding }" id="addToCart">
          <span *ngIf="!product?.preorder && (source === 'details' || source === 'details-bar')" 
            class="add-to-cart-text d-flex fs-24 lh-24 w-100">
            <mat-icon 
              class="material-icons material-symbols-outlined mr-1" 
              [ngClass]="{'d-md-inline-block d-none': source === 'details-bar'}"
              aria-hidden="false">
              shopping_cart
            </mat-icon>
            <span 
              class="text-capitalize"
              [ngClass]="{'fs-sm-12': source === 'details-bar'}"
            >
              {{ 'button.addToCart' | translate }}
            </span>
          </span>

          <span *ngIf="!product?.preorder && source !== 'details' && source !== 'details-bar'"
            class="add-to-cart-text d-flex">
            <mat-icon class="material-icons fs-24 lh-24" aria-hidden="false">add</mat-icon>
          </span>

          <span *ngIf="product?.preorder">
            {{ "productDetails.preorder" | translate }}
          </span>
        </button>

        <!-- decrement/increment amount -->
        <div class="control-btn-group w-100" *ngIf="product.amount > 0">
          <button mat-raised-button
            class="blueButton no-shadow"
            [ngClass]="{
              'w-50px': source !== 'details' && source !== 'details-bar',
              'h-40px w-40px': source === 'details',
              'p-0': source === 'details' || source === 'details-bar',
              'h-sm-24px w-sm-24px': source === 'details-bar'
            }"
            (click)="decrementAmountProduct(product)"
            id="decrementFromCart">
            <mat-icon class="material-icons fs-24 lh-24" aria-hidden="false">
              remove
            </mat-icon>
          </button>
          <span class="number-cart"
            [ngClass]="{
              'w-sm-40px': source === 'details-bar'
            }">
            {{ product.amount }}
          </span>
          <button mat-raised-button class="blueButton no-shadow"
            (click)="incrementAmountProduct(product)"
            [ngClass]="
              {
                'disabled': 
                  (product.max_per_order != null &&
                    product.max_per_order <= product.amount) ||
                  (product.can_buy != null &&
                    product.can_buy <= product.amount) ||
                  product.stock <= product.amount,
                'w-50px': source !== 'details' && source !== 'details-bar',
                'h-40px w-40px': source === 'details',
                'p-0': source === 'details' || source === 'details-bar',
                'h-sm-24px w-sm-24px': source === 'details-bar'
              }"
            id="incrementToCart">
            <mat-icon class="material-icons fs-24 lh-24" aria-hidden="false">
              add
            </mat-icon>
          </button>
          <app-loading *ngIf="product.loading_cart"></app-loading>
        </div>
      </div>

      <!-- notify btn not etisal -->
      <span *ngIf="
        (!product?.in_stock || product?.available_soon) && 
        environmentVariables?.ADD_TO_CART_TEXT_EN != '‎ +‎ ‎'">
        <button (click)="notifyProduct(product)" class="btn-to-cart" mat-raised-button
          [ngStyle]="{ padding: customPadding }" translate
          id="notifyProduct">
          {{ "card_product.notify" | translate }}
        </button>
      </span>

      <!-- notify etisal btn -->
      <span *ngIf="
        (!product?.in_stock || product?.available_soon) && 
        environmentVariables?.ADD_TO_CART_TEXT_EN == '‎ +‎ ‎'">
        <button (click)="notifyProduct(product)" 
          class="btn-to-cart w-100 h-40px d-flex align-items-center justify-center shadow-none" 
          mat-raised-button
          [ngStyle]="{ padding: customPadding }"
          translate
          id="notifyProduct">
          <mat-icon class="material-icons material-symbols-outlined" aria-hidden="false">
            notifications
          </mat-icon>
          {{ "card_product.notify" | translate }}
        </button>
      </span>
    </span>
  </ng-container>

  <ng-container
    *ngIf="
      product &&
      stylePopup &&
      product?.in_stock &&
      !product?.available_soon
    ">
    <span class="stylePopup">
      <button *ngIf="product.amount == 0 || !product.amount" class="blueButton w-150px px-2"
        (click)="addProductToCart(product)" id="addProductToCart">
        <mat-icon aria-hidden="false" class="material-icons" *ngIf="!product.loading_cart">
          add_shopping_cart
        </mat-icon>
        <app-loading *ngIf="product.loading_cart"></app-loading>
      </button>
      <div class="control-btn-group w-100" *ngIf="product.amount > 0">
        <button class="blueButton w-50px add-edit" (click)="decrementAmountProduct(product)"
          id="decrementAmountProduct">
          <span *ngIf="!product.loading_cart"> - </span>
          <app-loading *ngIf="product.loading_cart"></app-loading>
        </button>
        <span class="number-cart" [ngClass]="{'number-cart-width': source === 'details'}">{{ product.amount }}</span>
        <button 
          class="blueButton w-50px add-edit" 
          (click)="incrementAmountProduct(product)" 
          [ngClass]="
            (product.max_per_order != null &&
              product.max_per_order <= product.amount) ||
            (product.can_buy != null &&
              product.can_buy <= product.amount) ||
            product.stock <= product.amount
              ? 'disabled'
              : ''
          " 
          id="incrementAmountProduct">
          <span *ngIf="!product.loading_cart"> + </span>
          <app-loading *ngIf="product.loading_cart"></app-loading>
        </button>
        <app-loading *ngIf="product.loading_cart"></app-loading>
      </div>
    </span>
  </ng-container>

  <ng-template #emailDialgue class="dialogue">
    <mat-dialog-content class="mat-typography">
      <form [formGroup]="notifyForm" class="dialogue-body" (ngSubmit)="notifyProduct(product)">
        <p class="text-center">
          {{ "card_product.notifyText" | translate }}
        </p>

        <div class="form-group input-div">
          <mat-form-field class="w-100">
            <input type="email" class="form-control" [ngClass]="!notifyForm.valid ? 'invalid' : ''" id="recipient-name"
              formControlName="email" matInput placeholder="E-mail" />
            <mat-error
              *ngIf="
                email?.invalid &&
                (email?.dirty || email?.touched)
              "
              class="alert alert-danger">
              <div *ngIf="email?.errors?.required">
                {{ "validation_Input.requiredEmail" | translate }}
              </div>
              <div
                *ngIf="
                  email?.errors?.pattern ||
                  email?.errors?.email
              ">
                {{ "validation_Input.validEmail" | translate }}
              </div>
            </mat-error>
          </mat-form-field>
        </div>
      </form>
    </mat-dialog-content>

    <mat-dialog-actions align="center">
      <button mat-button mat-dialog-close>
        {{ "button.cancel" | translate }}
      </button>
      <button mat-button class="submit-btn" [ngClass]="!notifyForm.valid ? 'disabled' : ''" [mat-dialog-close]="true"
        cdkFocusInitial>
        {{ "button.notify" | translate }}
      </button>
    </mat-dialog-actions>
  </ng-template>
</ng-container>

<ng-container *ngIf="!environmentVariables?.GUEST_CAN_VIEW_PRICES">
  <button mat-raised-button class="blueButton px-2" (click)="redirectToProductFun(product)"
    style="outline: none !important ; height: 36px">
    <span>
      {{ "productDetails.viewDetails" | translate }}
    </span>
  </button>
</ng-container>